import { Tabs } from "@mantine/core";
import VideoCardDescription from "../Cards/VideoCardDescription";
interface Props {
    value: string;
}
export default function TabPanel({ value = "all" }: Props) {
    const videos = [
        {
            title: "Antworten zur Fernbehandlung",
            description:
                "Ich zeige unzählige Mechanismen des Energiefeldes und der Fernbehandlung auf.",
            hours: "10 hrs 12 min",
            numberOfVideos: "150",
        },
    ];
    return (
        <Tabs.Panel value={value}>
            <div className="grid grid-cols-3 gap-5 ">
                {videos.map((video) => (
                    <VideoCardDescription
                        title={video.title}
                        description={video.description}
                        key={video.title}
                    />
                ))}
            </div>
        </Tabs.Panel>
    );
}
